import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import clsx from 'clsx'
import { BulkAddElementInput } from 'models/getProjectElementNodesInput'
import React from 'react'
import { useBulkAddBarStyles } from './bulkAddBarStyles'

export interface BulkAddBarLeftSectionProps {
    addBulkAddItemsToProject: () => void
    selectedBulkAddElements?: BulkAddElementInput[]
    isBetaWorkspaceToggleEnabled?: boolean
}

const BulkAddBarLeftSection = ({
    selectedBulkAddElements,
    addBulkAddItemsToProject,
    isBetaWorkspaceToggleEnabled,
}: BulkAddBarLeftSectionProps) => {
    const classes = useBulkAddBarStyles({ isBetaWorkspaceToggleEnabled })

    return (
        <GridItem className={classes.searchFieldContainer}>
            <GridContainer>
                <GridItem className={classes.elementTypeItem}>
                    <Button
                        disableRipple
                        startIcon={
                            <AddCircleOutlineIcon
                                className={
                                    isBetaWorkspaceToggleEnabled
                                        ? classes.startIcon
                                        : ''
                                }
                            />
                        }
                        className={clsx(
                            classes.elementTypeButton,
                            isBetaWorkspaceToggleEnabled
                                ? classes.selectedElementsButton
                                : ''
                        )}
                        classes={{
                            endIcon: classes.checkIcon,
                        }}
                        onClick={addBulkAddItemsToProject}
                        data-testid={`addSelectedItemsButton`}
                    >
                        Add Selected Elements to Project
                    </Button>
                </GridItem>

                <GridItem>
                    <Typography className={classes.confirmationText}>
                        {selectedBulkAddElements?.length} element
                        {selectedBulkAddElements &&
                        selectedBulkAddElements?.length > 1
                            ? 's '
                            : ' '}
                        selected
                    </Typography>
                </GridItem>
            </GridContainer>
        </GridItem>
    )
}

export default BulkAddBarLeftSection
